
<!-- 查看明细 -->
<template>
  <div>
    <div class="title-content">
      <h-button-new type="default" size="middle" @click="handleCancel">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button-new>
    </div>
    <h-list-page class="level-container">
      <div class="item-module">
        <div class="title-style">{{ h_i18n('590668240abd2fbb992d3b4f7f31faf9') }}</div>
        <div class="btn-container">
          <h-search :title="h_i18n('8190915888889ed18be44ea0351d0448')">
            <h-date-picker v-model="perioddate" type="month" clearable @change="handleSubmitMonth"/>
          </h-search>
          <div class="primary-btn" style="margin-left: 4px;" @click="getOpenTable">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</div>
        </div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="520" class="myTable"
          :data="openTableData" size="small" style="width: 100%; min-height: 520px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: 16px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="plname" label="PL" width="80"></el-table-column>
          <el-table-column prop="plantcode" :label="h_i18n('3e67b3dcfe3cd8fb94ee06a461b4429b')"></el-table-column>
          <el-table-column prop="mtlgroupname" :label="h_i18n('9aa8f711298fef621b1c74335c2a8670')"></el-table-column>
          <el-table-column prop="materialcode" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')"></el-table-column>
          <el-table-column prop="materiallevel" :label="h_i18n('51f319df5a00ab66b2629ba13fd0d9c0')"></el-table-column>
          <el-table-column :label="h_i18n('278a9bf11803446e67d77cee0e37e30d')">
            <el-table-column prop="xcwastercntm" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="quantbm" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="xcwastblm" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="xcbaseline" :label="h_i18n('782a7e978d37effbe5132b0281f73273')"></el-table-column>
            <el-table-column prop="xcflag" :label="h_i18n('86e08f542b15b006e86798c980ba947f')"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('21a0a73b65c35feae1888ddd81780e67')">
            <el-table-column prop="scwastercnt3m" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="quantb3m" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="scwastbl3m" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="scbaseline3" :label="h_i18n('782a7e978d37effbe5132b0281f73273')"></el-table-column>
            <el-table-column prop="sc3mflag" :label="h_i18n('86e08f542b15b006e86798c980ba947f')"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('e99ea9e197e1f12daad1aaba2827bce7')">
            <el-table-column prop="scwastercnt6m" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="quantb6m" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="scwastbl6m" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="scbaseline6" :label="h_i18n('782a7e978d37effbe5132b0281f73273')"></el-table-column>
            <el-table-column prop="sc6mflag" :label="h_i18n('86e08f542b15b006e86798c980ba947f')"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('6a0685793fe4cec749f9e3d1732a8783')">
            <el-table-column prop="scwastercnt12m" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="quantb12m" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="scwastbl12m" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="scbaseline12" :label="h_i18n('782a7e978d37effbe5132b0281f73273')"></el-table-column>
            <el-table-column prop="sc12mflag" :label="h_i18n('86e08f542b15b006e86798c980ba947f')" width="88"></el-table-column>
          </el-table-column>
        </el-table>  
        <el-pagination background @current-change="handlePageChange"
          v-model:currentPage="openCurrentPage" :page-size="10" style="display: flex;flex-direction: row;justify-content: flex-end;margin-right:50px;"
          layout="total, prev, pager, next,jumper" :total="openTotal">
        </el-pagination>
      </div>
    </h-list-page>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
import hButton from '../../../views/Templates/h-button.vue';
export default {
  components: { hButton },
  data(){
    return{
      openTableData:[],
      openCurrentPage:1,
      openTotal:0,
      perioddate:''
    }
  },
  methods:{
    h_i18n,
    getOpenTable(){
      let self = this
      self.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      self.$http({
        method: "post",
        url: "/base/userevaluation/QualityLevelQdInfoSele",
        data: {
          vendorcode: self.$route.query.supplyCode||self.$route.query.vCode||self.$route.query.vcode,
          pageNo:self.openCurrentPage||1,
          pageSize: 10,
          perioddate: this.perioddate ? moment(this.perioddate).format('YYYY-MM') : ''
        },
      }).then((res) => {
        self.closeLoading()
        self.openTableData = res.data.data.res||[]
        self.openTotal = res.data.data.resnum
      }).catch(err=>{
        self.closeLoading()
        self.info(err.data.msg)
      })
    },
    handlePageChange(val){
      if(val){
        this.openCurrentPage = val
        this.getOpenTable()
      }else{
        this.openCurrentPage = 1
      }
    },
    handleSubmitMonth(val){
      if(val){
        this.perioddate = moment(val).format('YYYY-MM')
      }else{
        this.perioddate = ''
      }
    },
    handleCancel(){
      this.$router.go(-1)
    }
  },
  mounted(){
    this.perioddate = moment().format('YYYY-MM');
    this.getOpenTable()
  }
}
</script>
<style lang="scss" scoped>
.title-content{
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 45px;
}
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}

.item-module{
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 13px 16px 16px;
}
.title-style{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: #1D2129;
  font-weight: bold;
}
.primary-btn{
  box-sizing: border-box;
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#165DFF;
  color: #165dff;
  border-radius: 8px;
  font-size: 14px;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.btn-container{
  display: flex;
  flex-direction: row;
  margin-top: 12px;
}
.haier-list-page .el-table--border, .haier-list-page .haier-list-page .el-table--group{
  // border-right: none;
  border-bottom: none;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color:#e5e6eb !important;
}
</style>